import { DateTime } from "luxon";

export const DEFAULT_TIMEFRAME = "30 days";

export const ANALYTICS_EMBED_TIMEFRAME_OPTIONS = [
  { label: "Today", value: "today" },
  { label: "Yesterday", value: "yesterday" },
  { label: "Last week", value: "7 days" },
  { label: "Last 2 weeks", value: "14 days" },
  { label: "Last 30 Days", value: "30 days" },
  { label: "Last 90 Days", value: "90 days" },
  { label: "Last 180 Days", value: "180 days" },
  { label: "Last 365 Days", value: "365 days" },
  { label: "Year to Date", value: "this year to second" },
] as const;

export type Timeframe =
  (typeof ANALYTICS_EMBED_TIMEFRAME_OPTIONS)[number]["value"];

export function timeframeToStartAndEndDate(timeframe: Timeframe): {
  startDate?: string;
  endDate?: string;
} {
  switch (timeframe) {
    case "today":
      return {
        startDate: today(),
      };
    case "yesterday":
      return {
        startDate: today({ minusDays: 1 }),
        endDate: today({ minusDays: 1 }),
      };
    case "7 days":
      return {
        startDate: today({ minusDays: 6 }),
      };
    case "14 days":
      return {
        startDate: today({ minusDays: 13 }),
      };
    case "30 days":
      return {
        startDate: today({ minusDays: 29 }),
      };
    case "90 days":
      return {
        startDate: today({ minusDays: 89 }),
      };
    case "180 days":
      return {
        startDate: today({ minusDays: 179 }),
      };
    case "365 days":
      return {
        startDate: today({ minusDays: 364 }),
      };
    case "this year to second":
      return {
        startDate: DateTime.fromObject({
          year: DateTime.now().get("year"),
        }).toISODate()!,
      };
  }
}

function today(
  { minusDays }: { minusDays?: number } = { minusDays: 0 }
): string {
  return DateTime.now()
    .set({
      hour: 0,
      minute: 0,
      second: 0,
      millisecond: 0,
    })
    .minus({ days: minusDays })
    .toISODate();
}
